import { render, staticRenderFns } from "./CalendarsView.vue?vue&type=template&id=1c025c99&scoped=true&"
import script from "./CalendarsView.vue?vue&type=script&lang=js&"
export * from "./CalendarsView.vue?vue&type=script&lang=js&"
import style0 from "./CalendarsView.vue?vue&type=style&index=0&id=1c025c99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c025c99",
  null
  
)

export default component.exports